import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { SectorFormData } from '../../types';

export function useGetSectorById(id: string, options?: { enabled?: boolean }) {
	const forBinding = useForBindingId();
	return useQuery({
		enabled: options?.enabled,
		queryKey: ['sectorId', id, forBinding],
		queryFn: async () => (await api.get(`/user/prop/sector/get/${id}`, { params: { forBinding } })).data,
		select: (data) => {
			if (!data) return null;
			const { avatar, area } = data;

			const {
				name,
				areaId,
				size,
				plantingDate,
				lineSpacing,
				plantSpacing,
				amountOfPlants,
				propId,
				irrigationEfficiency,
				grossIrrigationDepth,
				operatingTime,
				dripperSpacing,
				dripperFlow,
				sprinklerSpacing,
				sprinklerFlow,
				microSprinklerSpacing,
				microSprinklerFlow,
			} = data;
			return {
				formData: {
					name,
					areaId,
					areaName: area?.name,
					size,
					plantingDate,
					lineSpacing,
					plantSpacing,
					amountOfPlants,
					irrigation: {
						irrigationEfficiency: irrigationEfficiency ?? '',
						grossIrrigationDepth,
						operatingTime,
						dripperSpacing,
						dripperFlow,
						sprinklerSpacing,
						sprinklerFlow,
						microSprinklerSpacing,
						microSprinklerFlow,
					},
				} as SectorFormData,
				propId: propId as string,
				areaId: areaId as string,
				avatarUrl: avatar?.url,
			};
		},
	});
}
